import { Statistics } from "./Dashboard/Statistics";
import { Alert } from "@mantine/core";
import UserManagement from "./Dashboard/UserManagement";

export default function Home() {
  return (
    <div className="space-y-8 p-6">
      <Alert title="User Management" color="green">
        This section allows you to manage users, including adding, removing, and updating user information. You can also assign roles and permissions to users to control their access to different features of the application.
    </Alert>
      {/* Key Statistics Section */}
      <section>
        <Statistics />
      </section>

      {/* Interactive Map Section */}
      <section>
        <UserManagement />
      </section>

    </div>
  );
}